import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import "../../assets/css/components/Profile/MemberComponent/Invite/Invite.css";
import "../../assets/css/components/Registration/Registration.css";
import ApiCalls from "../apis/api-calls";
import Utility from "../../common/utility";
import Cookies from "universal-cookie";

const Registration = inject("sharedStore", "loginStore")(observer(class Registration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
      passwordStatus: {
        passwordLength: {
          error: false,
          Msg: "Password must contain between 8 and 20 characters",
        },
        characterValue: {
          error: false,
          Msg: "Password must contain upper and lowercase letters",
        },
        specialCharacterValue: {
          error: false,
          Msg: "Password must contain at least one special character",
        },
        numericValue: {
          error: false,
          Msg: "Password must contain at least one number",
        },
        passwordMatch: {
          error: false,
          Msg: "Password and confirm password does not match.",
        },
      },
      isValidPassword: false,
      showPasswordErrorMessage: false,
      showConfirmPasswordErrorMessage: false,
      isPasswordError: false,
      clickedOutsidePassword: false,
      clickedOutsideConfirmPassword: false,
      responseError: false,
      responseMsg: "",
      loadPage: false,
      status: "",
    };
  }

  componentDidMount() {
    this.confirmEmail();
  }

  confirmEmail() {
    this.props.sharedStore.showLoader();
    const params = new URLSearchParams(this.props.location.search);
    const token = params.get("token");
    const type = params.get("type");
    if (token && type === "reg") {
      ApiCalls.confirmEmail(token, "reg")
        .then((res) => {
          this.props.sharedStore.hideLoader();
          let status = "";
          const cookies = new Cookies();
          console.log('cookies.get("auth")',cookies.get("auth"))
          if (cookies.get("auth") === "true") {
            console.log("cookies.get", cookies.get("auth"));
            cookies.set("auth", false, { domain: ".izenda.com" });
            cookies.set("auth", false, { path: "/" });
            this.props.loginStore.logout();
          }
          if (res.status_code === 200) {
            if (res.token_status === "active") {
              Utility.clearAllData();
              Utility.setData("user_id", res.user_id);

              status = "valid";
            } else {
              if (res.token_status === "expired") {
                this.props.history.push("/registration-expired", {
                  status: "request-access",
                });
              } else if (res.token_status === "used") {
                this.props.history.push("/registration-expired", {
                  status: "expired",
                });
              } else {
                this.props.history.push(`/register?token=${token}&type=reg`);
              }
            }
            this.setState({
              loadPage: true,
              status: status,
            });
          } else if (res.status_code === 409) {
            this.props.history.push("/registration-expired", {
              status: "token_used",
            });
          } else {
            this.setState({
              loadPage: false,
            });
            this.props.history.push("/invalid-token", { token: true });
          }
        })
        .catch((err) => {
          this.props.sharedStore.hideLoader();
          console.log("err", err);

          this.props.history.push("/invalid-token", { token: true });
        });
    } else {
      this.props.sharedStore.hideLoader();
      this.props.history.push("/invalid-token", { token: false });
    }
  }


  checkInputValidation(e) {
    let valid = true;
    let alphaRegex = new RegExp(/^[a-zA-Z\s.]*$/);
    valid = alphaRegex.test(e.target.value);
    return valid;
  }

  onInputChange = (e) => {
    const value = e.target.name;
    const { clickedOutsidePassword, password } = this.state;
    let { responseError, responseMsg } = this.state;
    if (responseError) {
      responseError = false;
      responseMsg = "";
      this.setState({ responseError, responseMsg });
    }
    if (value === "firstName" || value === "lastName") {
      if (this.checkInputValidation(e)) {
        this.setState({ [e.target.name]: e.target.value });
      }
    } else {
      this.setState(
        {
          [e.target.name]: e.target.value,
        },
        () => {
          if (value === "password" && clickedOutsidePassword) {
            this.validatePassword();
          }
          if (value === "confirmPassword" && password !== "") {
            this.validateConfirmPassword();
          }
        }
      );
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { firstName, lastName, password, confirmPassword } = this.state;

    this.props.sharedStore.showLoader();
    let data = {
      user_id: Utility.getData("user_id"),
      first_name: firstName,
      last_name: lastName,
      password: password,
      confirm_password: confirmPassword,
      //old: this.props.sharedStore && this.props.sharedStore.tempPassword,
    };
    ApiCalls.saveInviteeDetail(data).then((response) => {
      this.props.sharedStore.hideLoader();
      if (response && response.error === false) {
        this.props.history.push("/account-verification", { status: "active" });
      } else {
        this.props.history.push("/verification-expired", { status: "error" });
      }
    });
  };

  validatePassword = () => {
    const { password, confirmPassword } = this.state;
    let {
      passwordStatus,
      showPasswordErrorMessage,
      isPasswordError,
      showConfirmPasswordErrorMessage,
      isValidPassword,
      clickedOutsidePassword,
    } = this.state;
    if (clickedOutsidePassword === false) {
      clickedOutsidePassword = true;
      this.setState({ clickedOutsidePassword });
    }
    const response = Utility.isValidPassword(password);
    passwordStatus.passwordLength.error = response.lengthError;
    passwordStatus.characterValue.error = response.characterValueError;
    passwordStatus.specialCharacterValue.error = response.specialCharacterError;
    passwordStatus.numericValue.error = response.numericValueError;
    if (confirmPassword !== "" && password !== confirmPassword) {
      passwordStatus.passwordMatch.error = true;
      isValidPassword = false;
      showConfirmPasswordErrorMessage = passwordStatus.passwordMatch.error
        ? true
        : false;
      this.setState({ isValidPassword, showConfirmPasswordErrorMessage });
    } else {
      passwordStatus.passwordMatch.error = false;
      isValidPassword = false;
      showConfirmPasswordErrorMessage = passwordStatus.passwordMatch.error
        ? true
        : false;
      this.setState({ isValidPassword, showConfirmPasswordErrorMessage });
    }
    isPasswordError =
      passwordStatus.passwordLength.error ||
      passwordStatus.characterValue.error ||
      passwordStatus.specialCharacterValue.error ||
      passwordStatus.numericValue.error
        ? true
        : false;
    if (password === confirmPassword && isPasswordError === false) {
      isValidPassword = true;
      this.setState({ isValidPassword });
    }
    showPasswordErrorMessage = !isPasswordError ? false : true;
    this.setState({
      showPasswordErrorMessage,
      passwordStatus,
      isPasswordError,
    });
  };

  validateConfirmPassword = () => {
    const { password, confirmPassword, isPasswordError } = this.state;
    let {
      passwordStatus,
      showConfirmPasswordErrorMessage,
      isValidPassword,
      clickedOutsidePassword,
      clickedOutsideConfirmPassword,
    } = this.state;
    if (clickedOutsideConfirmPassword === false) {
      clickedOutsideConfirmPassword = true;
      this.setState({ clickedOutsideConfirmPassword });
    }
    if (password !== confirmPassword) {
      passwordStatus.passwordMatch.error = true;
      isValidPassword = false;
    } else {
      passwordStatus.passwordMatch.error = false;
      isValidPassword = false;
    }
    if (
      password === confirmPassword &&
      clickedOutsidePassword &&
      isPasswordError === false
    ) {
      isValidPassword = true;
    }
    showConfirmPasswordErrorMessage = passwordStatus.passwordMatch.error
      ? true
      : false;
    this.setState({
      passwordStatus,
      showConfirmPasswordErrorMessage,
      isValidPassword,
    });
  };

  renderRegistration() {}

  renderPage() {
    const {
      status,
      firstName,
      lastName,
      password,
      confirmPassword,
      passwordStatus,
      showPasswordErrorMessage,
      isPasswordError,
      showConfirmPasswordErrorMessage,
      isValidPassword,
      responseError,
      responseMsg,
    } = this.state;

    if (status === "") {
      return null;
    } else if (status === "expired") {
      this.props.history.push(`/registration-expired`, { status: "expired" });
    } else if (status === "valid") {
      return (
        <div className="loginBackground">
          <div className="mainWrapper custom_formwrapper">
            <div className="leftFormWrap">
              <h1>Welcome to the Izenda Customer Portal</h1>
            </div>
            <div className="rightFormWrap">
              <div className="form-wrapper">
                <div className="form-header">
                  <h3>Let's Get Started</h3>
                </div>
                <div className="form-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="field-wrapper">
                      <div className="form-group">
                        <label htmlFor="fName">
                          First Name<span>*</span>
                        </label>

                        <input
                          type="label"
                          maxLength="50"
                          id="fName"
                          autoComplete="off"
                          className="form-control"
                          name="firstName"
                          value={firstName}
                          onChange={(e) => this.onInputChange(e)}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="lName">
                          Last Name<span>*</span>
                        </label>

                        <input
                          type="label"
                          maxLength="50"
                          id="lName"
                          autoComplete="off"
                          className="form-control"
                          name="lastName"
                          value={lastName}
                          onChange={(e) => this.onInputChange(e)}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="rle">
                          Password<span>*</span>
                        </label>
                        <input
                          type="password"
                          maxLength="50"
                          autoComplete="off"
                          className={
                            !isPasswordError
                              ? "form-control"
                              : "form-control error-border"
                          }
                          onBlur={this.validatePassword}
                          name="password"
                          value={password}
                          onChange={(e) => this.onInputChange(e)}
                        />
                      </div>

                      {showPasswordErrorMessage ? (
                        <div className="msg_passwordError">
                          <p
                            className={
                              passwordStatus.passwordLength.error
                                ? "error-true"
                                : "error-false"
                            }
                          >
                            {passwordStatus.passwordLength.error ? (
                              <span className="fa fa-times error-true" />
                            ) : (
                              <span className="fa fa-check error-false" />
                            )}
                            {passwordStatus.passwordLength.Msg}
                          </p>
                          <p
                            className={
                              passwordStatus.characterValue.error
                                ? "error-true"
                                : "error-false"
                            }
                          >
                            {passwordStatus.characterValue.error ? (
                              <span className="fa fa-times error-true" />
                            ) : (
                              <span className="fa fa-check error-false" />
                            )}
                            {passwordStatus.characterValue.Msg}
                          </p>
                          <p
                            className={
                              passwordStatus.specialCharacterValue.error
                                ? "error-true"
                                : "error-false"
                            }
                          >
                            {passwordStatus.specialCharacterValue.error ? (
                              <span className="fa fa-times error-true" />
                            ) : (
                              <span className="fa fa-check error-false" />
                            )}
                            {passwordStatus.specialCharacterValue.Msg}
                          </p>
                          <p
                            className={
                              passwordStatus.numericValue.error
                                ? "error-true"
                                : "error-false"
                            }
                          >
                            {passwordStatus.numericValue.error ? (
                              <span className="fa fa-times error-true" />
                            ) : (
                              <span className="fa fa-check error-false" />
                            )}
                            {passwordStatus.numericValue.Msg}
                          </p>
                        </div>
                      ) : null}

                      <div className="form-group">
                        <label htmlFor="rle">
                          Confirm Password<span>*</span>
                        </label>
                        <input
                          type="password"
                          maxLength="50"
                          autoComplete="off"
                          className={
                            !passwordStatus.passwordMatch.error
                              ? "form-control"
                              : "form-control error-border"
                          }
                          onBlur={this.validateConfirmPassword}
                          name="confirmPassword"
                          id="e-mail"
                          value={confirmPassword}
                          onChange={(e) => this.onInputChange(e)}
                        />
                      </div>

                      {showConfirmPasswordErrorMessage ? (
                        <div className="field-group msg_passwordError">
                          <p
                            className={
                              passwordStatus.passwordMatch.error
                                ? "error-true"
                                : "error-false"
                            }
                          >
                            {passwordStatus.passwordMatch.error ? (
                              <span className="fa fa-times error-true" />
                            ) : (
                              <span className="fa fa-check error-false" />
                            )}
                            {passwordStatus.passwordMatch.Msg}
                          </p>
                        </div>
                      ) : null}

                      {responseError ? (
                        <div className="field-group msg_passwordError">
                          <p className="error-true">
                            <span className="fa fa-times error-true" />
                            {responseMsg}
                          </p>
                        </div>
                      ) : null}
                    </div>

                    <div className="termsText">
                      Completing registration indicates that you have read and
                      agree to our{" "}
                      <a
                        className="termsLink"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.izenda.com/terms/"
                      >
                        terms of service
                      </a>
                    </div>

                    <div className="text-center">
                      <button
                        type="submit"
                        className="btn btn-common"
                        disabled={
                          !isValidPassword ||
                          firstName.length === 0 ||
                          lastName.length === 0
                        }
                      >
                        Continue
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
      // this.props.history.push(`/register?token=${token}`)
    }
  }

  render() {
    const { loadPage } = this.state;
    document.body.classList.add("register");
    return (
      <div>
        {loadPage === "" ? null : this.renderPage()}
        {/* {status === 'valid' ? this.renderRegistration() : null} */}
      </div>
    );
  }
}));

export default Registration;



// WEBPACK FOOTER //
// ./src/components/Registration/Registration.jsx